import React, { useMemo } from 'react';
import classnames from 'classnames';

import config from 'config';

import Show from 'components/Show';
import Icon from 'components/Misc/Icon';
import { Title } from 'components/Misc/Typography';
import { Image } from 'components/Image';


const File = ({ active, file, setActive }) => {
	// Get file's type
	const type = useMemo(() => {
		if (config.extensions.image.includes(file.ext)) {
			return 'image';
		} else if (config.extensions.audio.includes(file.ext)) {
			return 'audio';
		} else if (config.extensions.video.includes(file.ext)) {
			return 'video';
		} else {
			return 'other';
		}
	}, [file]);

	// Concat file classnames
	const cls = classnames(
		'group flex flex-col items-center p-2 space-y-2 text-center rounded-lg cursor-pointer transition-all',
	);

	// Concat title classnames
	const titleClassName = classnames(
		'px-2 text-sm font-normal leading-normal rounded-md transition-colors',
		file.name === active && 'bg-neutral-100 dark:bg-neutral-700'
	);

	// Handle onClick event
	// @event: object | default onClick event
	const onClick = (event) => {
		event.preventDefault();

		// Update selected file
		setActive(active === file.name ? '' : file.name);
	};

	return (
		<div className={cls} onClick={onClick}>
			<div className="flex-1 flex items-center justify-center group-hover:opacity-80 transition-opacity">
				{/* Show preview if image */}
				<Show if={type === 'image'}>
					<Image
						src={file.path}
						alt={file.name}
						className="max-w-full max-h-24 rounded-md"
					/>
				</Show>

				{/* Show icon if not image */}
				<Show if={type === 'audio'}>
					<Icon
						icon="audiotrack"
						className="text-4xl text-neutral-700 dark:text-white"
					/>
				</Show>

				{/* Show icon if not image */}
				<Show if={type === 'video'}>
					<Icon
						icon="videocam"
						className="text-5xl text-neutral-700 dark:text-white"
					/>
				</Show>

				{/* Show icon if not image */}
				<Show if={type === 'other'}>
					<Icon
						icon="insert_drive_file"
						className="text-4xl text-neutral-700 dark:text-white"
					/>
				</Show>
			</div>

			{/* File's name */}
			<Title
				title={file.name}
				className={titleClassName}
			/>
		</div>
	);
};

export default File;